import classes from './titleWrapper.module.css'

const DEFAULT_TITLE = 'BET KALKULATORI'

const TitleWrapper = ({ title, children }) => {
  return (
    <div className={classes.titleWrapper}>
      <h2 className={classes.title}>
        <span>
          {title === null
            ? DEFAULT_TITLE
            : decodeURI(title.toLocaleUpperCase('sr'))}
        </span>
      </h2>
      <div className={classes.content}>{children}</div>
    </div>
  )
}

export default TitleWrapper
